{
  "title": "Assign to a Household",
  "body": "The {{objectType}} will be associated with the household, with the user as the primary contact.",
  "householdTitle": "Household",
  "name": "Name",
  "modal": {
    "title": " Assign to a Household"
  }
}
